import React from 'react';
import { styled } from '@this/constants/themes';
import type { LegSummaryJson } from '@this/src/domain/select_repository';
import SegmentClass from '@this/src/domain/transit/segment';
import TravelModeIcon from '../shared/TravelModeIcon';
import IndividualRouteModal from './IndividualRouteModal';

interface IndividualRouteInfoProps {
  legSummary: LegSummaryJson;
  segment: SegmentClass;
  isTrainOrFlight: boolean;
}

const IndividualRouteInfo: React.FC<IndividualRouteInfoProps> = ({ legSummary, segment, isTrainOrFlight }) => {
  return (
    <StyledSummary>
      {legSummary.from.express_station && legSummary.from.express_station !== legSummary.from.name && (
        <StyledBoxContentThin>
          <StyledLegTime />
          <div>乗車駅: {legSummary.from.name}</div>
        </StyledBoxContentThin>
      )}

      <StyledBoxContent>
        <StyledLegTime>{legSummary.from.time}</StyledLegTime>
        <StyledBoxTitle>出発</StyledBoxTitle>
        <StyledSpace className={isTrainOrFlight ? 'select-transport-box__button_exist_leg_station' : ''}>
          <StyledName>{legSummary.from.express_station || legSummary.from.name}</StyledName>
        </StyledSpace>
      </StyledBoxContent>

      <StyledBoxContent>
        <StyledLegTimeSpace />
        <TravelModeIcon type={legSummary.type} />

        {legSummary.name?.match(/\//) ? (
          <>
            {legSummary.name.split('/').map((n: string) => (
              <React.Fragment key={`transport_${n}`}>
                <StyledImageBox>
                  <StyledImage src={SegmentClass.imagePathByName(n)} />
                </StyledImageBox>
                <StyledSpace>{n}</StyledSpace>
              </React.Fragment>
            ))}
          </>
        ) : (
          <>
            <StyledImageBox>
              <StyledImage src={SegmentClass.imagePathByName(legSummary.name)} />
            </StyledImageBox>
            <StyledSpace>{legSummary.name}</StyledSpace>
          </>
        )}
        <IndividualRouteModal segment={segment} legSummary={legSummary} />
      </StyledBoxContent>
      <StyledBoxContent>
        <StyledLegTime>{legSummary.to.time}</StyledLegTime>
        <StyledBoxTitle>到着</StyledBoxTitle>
        <StyledSpace className={isTrainOrFlight ? 'select-transport-box__button_exist_leg_station' : ''}>
          <StyledName>{legSummary.to.express_station || legSummary.to.name}</StyledName>
        </StyledSpace>
      </StyledBoxContent>

      {legSummary.to.express_station && legSummary.to.express_station !== legSummary.to.name && (
        <StyledBoxContentThin>
          <StyledLegTime />
          <div>降車駅: {legSummary.to.name}</div>
        </StyledBoxContentThin>
      )}
    </StyledSummary>
  );
};

const StyledSummary = styled.div`
  padding: 0;
  margin: 0;
  display: block;
  padding: 2px 5px 2px 10px;
`;

const StyledName = styled.div`
  font-size: 12px;
  font-weight: bold;
`;

const StyledLegTime = styled.div`
  min-width: 50px;
  color: #3675ff;
  font-size: 13px;
  height: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  @media screen and (max-width: 768px) {
    min-width: 40px;
  }
`;

const StyledLegTimeSpace = styled.div`
  min-width: 50px;
  color: #3675ff;
  font-size: 13px;
  height: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  @media screen and (max-width: 768px) {
    min-width: 0;
  }
`;

const StyledBoxTitle = styled.div`
  background: #aaa;
  color: white;
  min-width: 25px;
  line-height: 16px;
  margin-right: 10px;
  height: 16px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
`;

const StyledBoxContent = styled.div`
  display: flex;
  padding: 5px;
  align-items: center;
`;

const StyledBoxContentThin = styled.div`
  display: flex;
  padding: 2px;
`;

const StyledImageBox = styled.div`
  display: flex;
  min-width: 20px;
  margin-right: 5px;
`;

const StyledImage = styled.img`
  height: 20px;
  margin-left: 5px;
`;

const StyledSpace = styled.div`
  margin-right: 10px;
`;

export default IndividualRouteInfo;
